import React from "react";
import Modal from "../Modal";
import DocumentEditor, { DocumentEditorProps } from "./DocumentEditor";

export type DocumentEditorModalProps = DocumentEditorProps & { visible: boolean };

/**
 * Inline modal wrapper around the DocumentEditor content, for screens that render the editor directly
 * (driven by their own `visible` state) instead of through DocumentManager. These are mounted IN PLACE
 * inside their screen, so a real RN Modal presents from that screen's view controller and stacks
 * correctly on iOS. The DocumentManager flow instead uses the DocumentEditor navigation SCREEN
 * (components/document/DocumentEditorScreen.tsx) — the one that must appear over other native modals.
 */
const DocumentEditorModal = ({ visible, ...props }: DocumentEditorModalProps) => (
    <Modal visible={visible} onClose={props.onClose} hideCloseButton edges={{ top: "off" }}>
        <DocumentEditor {...props} />
    </Modal>
);

export default DocumentEditorModal;
